export const PROGRAM_LAB_ADDRESS_FIELDS = [
  ["street", "Street address"],
  ["apt", "Apartment or suite (optional)"],
  ["city", "City"],
  ["state", "State"],
  ["zip", "ZIP code"],
];

export const PROGRAM_LAB_ADDRESS_PLACEHOLDERS = {
  street: "1240 Mission St",
  apt: "Apt 4B (optional)",
  city: "San Francisco",
  state: "CA",
  zip: "94103",
};

export const PROGRAM_LAB_CONSENTS = [
  ["hipaa", "I acknowledge the HIPAA privacy notice."],
  ["terms", "I agree to the laboratory Terms of Service."],
  ["telehealth", "I consent to telehealth care related to these results."],
];

export const COLLECTION_METHOD_OPTIONS = {
  draw_site: ["draw_site"],
  walk_in_test: ["walk_in_test"],
  at_home_phlebotomy: ["at_home_phlebotomy"],
  testkit: ["testkit"],
  on_site_collection: ["on_site_collection"],
};
